module.exports = __webpack_public_path__ + "img/Toyota-2019-Sequoia-2.1e090c20.png";